<template>
  <div class="page-template">
    <div class="page-head">
      <div class="title">
        <van-icon name="balance-pay" size=".36rem" />收银台</div>
      <div class="money">
        <em style="font-size: 20px">￥</em>{{ order.money }}
      </div>
    </div>

    <div class="page-info">
      <van-form>
        <van-field v-model="form.phone" label="手机号" label-width="1.2rem" placeholder="必填，作为购买凭证"
          :rules="[{ pattern, message: '请输入正确的手机号' }]" style="border-radius: 10px 10px 0 0" />
        <van-field label="附加服务" label-width="1.2rem">
          <template #input>
            <van-checkbox-group v-model="form.append" direction="vertical">
              <van-checkbox @click="append(1)" name="1" shape="square" style="margin-bottom: 5px"
                v-show="shopInfo.deliver_phone == 1">发送到我手机({{
                  shopInfo.deliver_phone_price == 0
                    ? "免费"
                    : shopInfo.deliver_phone_price + "元"
                }})</van-checkbox>
              <van-checkbox @click="append(2)" name="2" shape="square" v-show="shopInfo.deliver_email == 1">发送到我邮箱(免费)
              </van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field v-show="form.sendEmail" v-model="form.email" label="邮箱" label-width="1.2rem" placeholder="必填，作为购买凭证"
          :rules="[{ validator, message: '请输入正确的手机号' }]" />
        <van-field v-model="form.remarks" rows="2" autosize maxlength="100" show-word-limit label-width="1.2rem"
          label="订单备注" type="textarea" placeholder="选填，请先和客服协商一致" style="border-radius: 0 0 10px 10px" />
      </van-form>
    </div>
    <div class="alert-info">
      提示：付款后若未自动跳转，请前往首页->订单查询，即可查询所购商品内容
    </div>
    <div class="page-footer">
      <van-button round type="info" @click="submit('alipay')" :disabled="basic.alipay_type == 0 ? true : false">
        <img src="../../../../assets/img/zfb.png" alt="GEEK" />
        {{ basic.alipay_type == 0 ? "暂时维护" : "支付宝支付" }}</van-button>
      <van-button round type="primary" @click="submit('wxpay')" :disabled="basic.wxpay_type == 0 ? true : false">
        <img src="../../../../assets/img/wx.png" alt="GEEK" />
        {{ basic.wxpay_type == 0 ? "暂时维护" : "微信支付" }}</van-button>
    </div>
  </div>
</template>

<script>
  import {
    postPay,
    postSubmit,
    getSystem,
    getSingleShop
  } from "@/api/index";
  import {
    Toast
  } from "vant";
  import cookie from "@/utils/store/cookie";
  export default {
    data() {
      return {
        pattern: /^1[3456789]\d{9}$/,
        form: {
          phone: "",
          remarks: "",
          append: [],
          email: "",
          sendPhone: false,
          sendEmail: false,

        },
        order: {},
        basic: {},
        shopInfo: {}
      };
    },
    computed: {
      sendPhone() {
        return this.form.sendPhone;
      },
    },
    watch: {
      sendPhone(newVal) {
        if (newVal) {
          this.order.money = Number(this.order.money) + Number(this.shopInfo.deliver_phone_price)
        } else {
          this.order.money = this.$store.state.order.money
        }
      },

    },
    created() {
      // this.order = {
      //   ...this.$store.state.order
      // };
      this.order = JSON.parse(sessionStorage.getItem('order'))
      this._getSingleShop(this.order.goods_id)
      this._getSystem();
    },
    methods: {
      // 校验函数返回 true 表示校验通过，false 表示不通过
      validator(val) {
        return /^[0-9a-z]\w+[0-9a-z]@\w{2,}\.(com|cn|edu|org|net|cc|vip|top)$/.test(
          val
        );
      },
      // 复选框
      append(i) {
        if (i == 1) {
          this.form.sendPhone ?
            (this.form.sendPhone = false) :
            (this.form.sendPhone = true);
        } else {
          this.form.sendEmail ?
            (this.form.sendEmail = false) :
            (this.form.sendEmail = true);
        }
      },

      // 提交订单
      submit(payment) {
        if (!this.form.phone || !this.pattern.test(this.form.phone)) {
          return Toast("请填写正确的手机号码");
        }
        if (this.form.sendEmail) {
          if (!this.form.email || !this.validator(this.form.email)) {
            return Toast("请填写正确的邮箱");
          }
        }

        Toast.loading({
          message: "正在提交订单",
          forbidClick: true,
          duration: 3000,
          loadingType: "spinner",
        });
        cookie.set('phone', this.form.phone, 30);

        postSubmit({
          norms_id: this.order.norms_id,
          count: this.order.count,
          payment: payment,
          send: this.form.sendPhone ? 1 : 0,
          phone: this.form.phone,
          email: this.form.email,
          remarks: this.form.remarks,
        }).then((res) => {
          if (res.code == 200) {
            Toast.clear();

            if (payment == "alipay") {
              if (this.basic.alipay_type == 1 || this.basic.alipay_type == 4) {
                this._postPay(res.data);
              } else if (this.basic.alipay_type == 2) {
                this.$router.push("/codepay/" + res.data);
              } else if (this.basic.alipay_type == 3) {
                this.$router.push("/f2fpay/" + res.data);
              } else if (this.basic.alipay_type == 5) {
                this.$router.push("/geekpay/" + res.data);
              }
            } else {
              if (this.basic.wxpay_type == 1) {
                this.$router.push("/wxpay/" + res.data);
              } else if (this.basic.wxpay_type == 2) {
                this.$router.push("/codepay/" + res.data);
              } else if (this.basic.wxpay_type == 4) {
                this._postPay(res.data);
              } else if (this.basic.wxpay_type == 5) {
                this.$router.push("/geekpay/" + res.data);
              }
            }
          } else {
            Toast(res.msg);
          }
        });
      },
      // 提交支付宝支付
      _postPay(out_trade_no) {
        Toast.loading({
          message: "正在跳转支付",
          forbidClick: true,
          duration: 3000,
          loadingType: "spinner",
        });
        postPay({
          out_trade_no: out_trade_no,
        }).then((res) => {
          if (res.code == 200) {
            Toast.clear();
            const form = res.data;
            const div = document.createElement("div");
            div.innerHTML = form;
            document.body.append(div);
            document.forms["alipaysubmit"].submit();
          } else {
            Toast.fail(res.msg);
          }
        });
      },
      // 获取列表
      _getSystem() {
        getSystem().then((res) => {
          this.basic = res.data;
        });
      },
      // 获取商品
      _getSingleShop(id) {
        getSingleShop({
          id,
        }).then((res) => {
          if (res.code == 200) {
            this.shopInfo = res.data;
          }
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  @import "../../../../assets/css/clean.css";
  @deep: ~">>>";

  .page-template {
    background-color: rgb(245, 246, 247);
    min-height: 100vh;
    position: relative;
    overflow: hidden;

    .page-head {
      background: #ffffff;
      text-align: center;
      margin: 10px;
      border-radius: 10px 10px 0 0;
      position: relative;
      // border-bottom: 2px solid red;

      .title {
        height: 0.8rem;
        line-height: 0.8rem;
        font-size: .32rem;
        border-bottom: 1px solid #e8eaec;

        .van-icon {
          vertical-align: middle;
          margin-right: 5px;
        }
      }

      .money {
        line-height: 2rem;
        font-size: .7rem;
        color: red;
      }
    }

    .page-head::before {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      height: 2px;
      background: -webkit-repeating-linear-gradient(135deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
      background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
      background-size: 80px;
      content: '';
    }

    .page-info {
      // margin-top: 10px;
      background: #ffffff;
      margin: 10px;
      border-radius: 10px;

      .van-cell {
        font-size: .28rem;
        line-height: .48rem;

        @{deep}.van-field__label {
          font-size: .28rem;
        }

        @{deep}.van-field__control {
          font-size: .28rem;
        }

        @{deep}.van-checkbox__icon {
          font-size: .4rem;
        }

        @{deep}.van-checkbox__label {
          line-height: .4rem;
          font-size: .28rem;
        }
      }
    }

    .alert-info {
      margin: 10px;
      background-color: #f0faff;
      border: 1px solid #ffffff;
      position: relative;
      padding: 8px;
      border-radius: 10px;
      height: 1rem;
      color: #515a6e;
      font-size: .28rem;
      line-height: .32rem;
      margin-bottom: 10px;
    }

    .page-footer {
      position: fixed;
      bottom: 0;
      left: 0;
      height: 1.2rem;
      padding: 0.16rem;
      width: 100%;
      display: flex;
      justify-content: space-between;

      .van-button {
        width: 48%;
        height: .88rem;
        font-size: .28rem;

        @{deep}.van-button__text {
          font-size: .28rem;

        }

        img {
          display: inline-block;
          vertical-align: middle;
          width: 0.4rem;
          height: 0.4rem;
        }
      }
    }
  }
</style>